export function roundUp(num, precision) {
  if (num === null) {
    return null;
  }
  return Math.ceil(num * precision) / precision;
}

export function displayDecimal(num, precision) {
  if (num === null) {
    return null;
  }
  return parseFloat(Math.round(num * precision) / precision);
}

export function displayInt(int) {
  return (int && int.toFixed(0)) || 0;
}

export function displayFloat(float) {
  return (float && float.toFixed(2)) || 0;
}

export function percent(int, total) {
  if (int === 0) return "0%";
  if (!int) return null;
  return `${(int / total * 100).toFixed(0)}%`;
}

export function decimalField(val) {
  if (!val) return val;
  if (!val.includes(".")) return val;

  return displayFloat(parseFloat(val));
}



// WEBPACK FOOTER //
// ./app/lib/formatters/number.js